function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { createRoot } from 'react-dom/client';
import { all } from '@awesome.me/kit-95318a50d1/icons';
import { faGoogle, faLinkedin, faWeixin } from '@fortawesome/free-brands-svg-icons';
import { config as faConfig, dom, library } from '@fortawesome/fontawesome-svg-core';
import { ResearcherApp, ResearcherProvider } from './researcher';
// import HeaderContainer from './researcher/order-form/order/components/HeaderContainer.jsx';
// import FooterContainer from './researcher/order-form/order/components/FooterContainer.jsx';
import HeaderContainer from './rubriq/components/HeaderContainer';
import FooterContainer from './rubriq/components/FooterContainer';
import config from './config';
import { redirectToVerification, verificationTokenFromPath } from './shared/helper/email-verification-redirect';
import { checkoutLinkTokenFromPath, redirectToCheckoutLink } from './rubriq/helpers/emailCheckoutLink';
import './rubriq/styles';
import './researcher/styles';
library.add.apply(library, _toConsumableArray(all).concat([faGoogle, faLinkedin, faWeixin]));
faConfig.searchPseudoElements = true;
dom.watch();
// A verification link only has to reach megatron, so leave before the app mounts: booting
// it would put a loading screen in front of a page the researcher never really sees. Every
// other URL carries on and renders as usual.
var verificationToken = verificationTokenFromPath();
// The same goes for a checkout link from an email: megatron decides where it leads.
var checkoutLinkToken = checkoutLinkTokenFromPath();
var researcherAppContainer = document.querySelector('#researcher-app');
if (verificationToken) {
  redirectToVerification(verificationToken);
} else if (checkoutLinkToken) {
  redirectToCheckoutLink(checkoutLinkToken);
} else if (researcherAppContainer) {
  var root = createRoot(researcherAppContainer);
  root.render(/*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(ResearcherProvider, {
    config: config,
    translationContext: "aje"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderContainer, null), /*#__PURE__*/React.createElement("div", {
    id: "BodyContent"
  }, /*#__PURE__*/React.createElement(ResearcherApp, null)), /*#__PURE__*/React.createElement(FooterContainer, null)))));
}